<template>
  <div class="contract-order-frame-bd">
    <div class="table-bd">
      <custom-table index :data="tableList" tableCode="contract_order_frame" :slots="['detailAddress', 'productDetail']">
        <template v-slot:detailAddress="scope">
          <span>
            {{ scope.row.country }}
            <span v-if="scope.row.province !== scope.row.city">{{ scope.row.province }}</span>
            {{ scope.row.city }}{{ scope.row.useAddress }}
          </span>
        </template>
        <template v-slot:productDetail="scope">
          <el-popover placement="bottom" width="420" trigger="hover" v-if="scope.row.goodsCountList">
            <el-table :data="scope.row.goodsCountList">
              <el-table-column width="100" property="productCode" :label="$t('crm_contract_order_frame.xing_hao')"></el-table-column>
              <el-table-column width="70" property="bookingNum" :label="$t('crm_contract_order_frame.shu_liang')"></el-table-column>
              <el-table-column width="70" property="rentalTerm" :label="$t('crm_contract_order_frame.zu_lin_yue_shu')"></el-table-column>
              <el-table-column width="70" property="unitPrice" :label="$t('crm_contract_order_frame.zu_jin_yue')"></el-table-column>
            </el-table>
            <el-button slot="reference" type="text">{{ $t('crm_contract_order_frame.cksbxq') }}</el-button>
          </el-popover>
          <el-button v-else type="text">{{ $t('crm_contract_order_frame.cksbxq') }}</el-button>
        </template>
      </custom-table>
    </div>
    <div class="table-page">
      <custom-page :total="totalRows" :page="formSearch.pageNum" :size="formSearch.pageSize" @change="onPageChange"></custom-page>
    </div>
  </div>
</template>

<script>
import apis from '@/utils/apis';

export default {
  name: '',
  props: {
    detail: {
      type: Object,
      default() {
        return {};
      }
    },
    rule: {
      type: Object,
      default() {
        return {};
      }
    }
  },
  data() {
    return {
      formSearch: {
        parentContractId: '',
        orderBy: '',
        orderType: '',
        pageSize: 20,
        pageNum: 1
      },
      tableList: [],
      totalRows: 0
    };
  },
  mounted: function () {
    this.formSearch.parentContractId = this.getJump('contractId');
    this.getTableList();
    this.getFuncView();
  },
  methods: {
    // 获取表格数据列表
    getTableList: function () {
      this.$getJSON(apis.crmContractOrderPage, this.formSearch).then((res) => {
        this.tableList = res.data.list;
        this.totalRows = res.data.total;
      });
    },
    // 分页变更
    onPageChange: function ({ page, size }) {
      this.formSearch.pageNum = page;
      this.formSearch.pageSize = size || this.formSearch.pageSize;
      this.getTableList();
    }
  }
};
</script>

<style lang="scss">
@import 'style/colors.scss';

.contract-order-frame-bd {
  background-color: #ffffff;
  padding: 24px;
}
</style>
